import React from 'react';
import { useTranslation } from 'react-i18next';
import { vars } from '../../../../../Theme';
import { CircularProgress } from '@mui/material';
import { FileStateModel } from '../../../../../redux/import/sliceImportFileUpload';
import { mdiAlertCircle } from '@mdi/js';
import Icon from '@mdi/react';
import AppTooltip from '../../../AppTooltip/AppTooltip';

export default (fileModel: FileStateModel) => {
    const { t } = useTranslation('translations', { keyPrefix: 'filePrecheckStatus' });

    if (fileModel.precheckState.isLoading) {
        return <CircularProgress size='24px' />;
    }

    if (fileModel.precheckState.reason) {
        return (
            <AppTooltip title={t(fileModel.precheckState.reason)}>
                <Icon path={mdiAlertCircle} size={1} color={vars.errorRed} />
            </AppTooltip>
        );
    }

    return <></>;
};
